<template>
  <div class="upload-logo">
    <label class="logo-container" v-if="temAcesso('Logo')">
      <div v-show="!hasLogo" id="logo-franqueador" v-loading="loading">
        <i class="icon fas fa-upload"></i> Logo
      </div>
      <el-tooltip class="item" effect="dark" content="Alterar o logo" placement="bottom">
        <img 
          v-show="hasLogo && !loading" 
          :src="logoSrc" 
          alt="logo" 
          id="logo-franqueador-img" 
          ref="logo-preview" 
        />
      </el-tooltip>
      <input 
        type="file" 
        @change="handleUploadLogo" 
        ref="logoInput" 
        id="logo-input" 
        name="logo-franqueador" 
        accept="image/png, image/jpeg"
      />
    </label>
    <label class="logo-container" v-else>
      <img v-loading="loading" v-show="hasLogo" src="" alt="logo" id="logo-franqueador-img" ref="logo-preview" />
    </label>
  </div>
</template>

<script>
export default {
  name: 'UploadLogo',
  data() {
    return {
      hasLogo: false,
      loading: false,
      logoSrc: '',
    };
  },
  methods: {
    async getLogo(){
      this.loading = true;
			this.axios.get(this.$urls.LOGO, { responseType: 'blob' })
			.then(res => {
				if(res.data && res.data.size > 0){
					let logo = (this.$refs['logo-preview']);
					logo.src = URL.createObjectURL(res.data);
					this.hasLogo = true;
					return;
				}
				this.hasLogo = false;
			})
			.catch((err) => {
				this.hasLogo = false;
				console.log(err);
			}).finally(() => {
        this.loading = false;
      });
		},
    handleUploadLogo(event) {
      const file = event.target.files[0];

      if (file) {
        this.loading = true;
        const reader = new FileReader();
        
        reader.onload = (e) => {
          this.logoSrc = e.target.result;
          this.hasLogo = true;
        };

        reader.onerror = () => {
          //this.$message.error('Houve um erro ao carregar o Logo');
          this.loading = false;
        };

        reader.onloadend = () => {
          const formData = new FormData();
          formData.append('file', file);

          this.axios.post(this.$urls.LOGO, formData)
            .then(() => {
              //this.$message.success('Logo carregado com sucesso');
              this.loading = false;
            })
            .catch(() => {
              //this.$message.error('Houve um erro ao carregar o Logo');
              this.loading = false;
            });
        };

        reader.readAsDataURL(file);
      }
    },
  },
  async mounted(){
		this.getLogo();
	},
};
</script>

<style lang="scss" scoped>
.upload-logo {
  width: 100%;
  padding: 5px 0 0;
}
.logo-container {
  display: flex;
  justify-content: center;
  width: 100%;
  
  $border-color: #fff;
  $border-radius: 19px;
  $img-max-width: 130px;
  $img-max-height: 30px;

  #logo-franqueador {
    width: 147px;
    height: 35px;
    border: 1px dashed $border-color;
    color: $border-color;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: $border-radius;
    cursor: pointer;
    box-sizing: border-box;
    transition: border-color 0.3s ease;
    
    &:hover {
      border-color: lighten($border-color, 20%);
    }
  }

  #logo-franqueador-img {
    max-width: $img-max-width;
    max-height: $img-max-height;
    border-radius: 4px;
    cursor: pointer;
    transition: transform 0.2s ease;

    &:hover {
      transform: scale(1.05);
    }
  }

  #logo-input {
    display: none;
  }
}
</style>
